import { useRouter } from 'next/router';

export type IKey = string | Record<string, any>;

export function translate(locale: string | undefined, key: Record<string, any>, data?: Record<string, any>): string | JSX.Element {

  if (!locale) {
    throw new Error('No locale set');
  }

  let translation: any;

  if (typeof key !== 'string') {
    translation = key[locale];
  }

  if (typeof translation === 'function') {
    return data
      ? translation(data)
      : translation();
  }

  if (data && typeof translation === 'string') {
    for (const valueKey in data) {
      while (translation.includes(`{{ ${valueKey} }}`)) {
        translation = translation.replace(`{{ ${valueKey} }}`, data[valueKey]);
      }
    }
  }
  return translation
};

export function useTranslation(): { t(key: Record<string, any>, data?: Record<string, any>): string | JSX.Element } {
  const { locale } = useRouter();
  return { t: (key, data) => translate(locale, key, data) };
}
